import {
  applyMenuPosition,
  calculateHorizontalPosition,
  calculateVerticalPosition,
} from "helpers/dropdown_positioning"
import MenuController from "./menu_controller"

export default class AutocompleteMenuController extends MenuController {
  static outlets = ["autocomplete", "autocomplete-text-field"]

  connect() {
    super.connect()
    this.boundUpdatePosition = this.#updatePosition.bind(this)

    this.resizeObserver = new ResizeObserver(this.boundUpdatePosition)
    this.resizeObserver.observe(this.menuTarget)

    window.addEventListener("resize", this.boundUpdatePosition)

    this.#updatePosition()
  }

  disconnect() {
    this.resizeObserver.disconnect()
    window.removeEventListener("resize", this.boundUpdatePosition)
  }

  selectItem(event) {
    if (!this.getAutocompleteOutlet().element.contains(event.target)) {
      return
    }

    this.selectableItemTargets[this.currentItemIndex].click()
    this.getAutocompleteOutlet().inputTarget.blur()
  }

  closeMenu() {
    this.getAutocompleteOutlet().hideSuggestions()
    this.getAutocompleteOutlet().inputTarget.blur()
  }

  getAutocompleteOutlet() {
    if (this.hasAutocompleteOutlet) {
      return this.autocompleteOutlet
    } else if (this.hasAutocompleteTextFieldOutlet) {
      return this.autocompleteTextFieldOutlet
    }
  }

  #updatePosition() {
    const triggerRect =
      this.getAutocompleteOutlet().inputTarget.getBoundingClientRect()

    this.menuTarget.style.position = "fixed"
    this._setMenuWidth(triggerRect)

    const menuRect = this.menuTarget.getBoundingClientRect()

    const { top, left } = this.#calculateMenuCoordinates(triggerRect, menuRect)
    applyMenuPosition(this.menuTarget, top, left)
  }

  #calculateMenuCoordinates(triggerRect, menuRect) {
    const top = calculateVerticalPosition(triggerRect, menuRect)
    const left = calculateHorizontalPosition(triggerRect.left, menuRect)

    return { top, left }
  }
}
